import { render, staticRenderFns } from "./RecoveryPage.vue?vue&type=template&id=8d7724d2&"
import script from "./RecoveryPage.vue?vue&type=script&lang=js&"
export * from "./RecoveryPage.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryPage.vue?vue&type=style&index=0&id=8d7724d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports